import { isDev } from '../util';

export const getDevLang = () => (isDev() ? 'zh' : import.meta.env.VITE_APP_LANG);

export const getDevToken = () =>
  `Bearer eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkVGltZSI6MTc2NjQwODgzMjIxNywiY2xpZW50IjoiQ3JlZml0IiwibGlua1R5cGUiOiIiLCJ1c2VySWQiOiIxNTA2NTY1In0.CqiAuVoRdI6lyXrB64lbc5tl1bR0rqW6v0ZmDv-Xwla6kebu-Z3GRvfBkv1xHoswLLJdhdnE9t_HN0ywZjID2w`;

export const getDevIsUIv2 = () =>
  isDev() ? true : import.meta.env.VITE_APP_NEW_VERSION === 'true';
